import { DataTable } from "./components/Table";
import { Loader } from "./components/loader/loader";
const purchaserID = () => {
    return localStorage?.getItem('userID') ?? '';
}

export { DataTable, purchaserID, Loader }